import { render, staticRenderFns } from "./LangSwitcher.vue?vue&type=template&id=7ca30188&"
import script from "./LangSwitcher.vue?vue&type=script&lang=ts&"
export * from "./LangSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./LangSwitcher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports